import React, {FC} from 'react';
import {Marker, MarkerProps as _MarkerProps} from 'react-map-gl';
import MarkerIcon, {LocationType} from 'components/BaseMap/Marker/MarkerIcon';

export type MarkerProps = _MarkerProps & {
	id: string
	longitude: number
	latitude: number
	type: LocationType
	onClick?: () => void
}

const _Marker: FC<MarkerProps> = ({
	children,
	onClick,
	type,
	...props
}) => {
	return (
		<Marker {...props} style={props.style || {cursor: 'pointer'}}>
			{children ?? (
				<MarkerIcon
					onClick={onClick}
					type={type}
				/>
			)}
		</Marker>
	);
};

export default _Marker;
